import {Box} from '@dropbox/dig-foundations';
import type {EmployeeLdap} from 'client';
import {EmployeeButton} from 'components/DSYS/EmployeeButton';
import {useState} from 'react';

import {workstreamsPersonPath} from './workstreamsRoutes';

/**
 * /workstreams: a byline's avatar + name as the DSYS EmployeeButton
 * (borderless shade), linking to their workstreams here; the page intercepts
 * the click to scope itself to them (their header links on to their profile).
 * The name darkens while hovered. Its click stays its own (cards toggle on
 * header clicks), and
 * -4px cancels the button's padding so the byline keeps its height.
 */
export const PersonLink = ({person}: {person: EmployeeLdap}) => {
  const [hovered, setHovered] = useState(false);
  return (
    <Box
      onClick={(event: React.MouseEvent) => event.stopPropagation()}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{margin: '-4px 0', flexShrink: 0}}
    >
      <EmployeeButton
        employee={person}
        to={workstreamsPersonPath(person.ldap)}
        avatarSize="xsmall"
        size="small"
        isBold
        color={hovered ? 'standard' : 'subtle'}
      />
    </Box>
  );
};
